import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCreatePnlCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	startYear?: number | null | Ref<number | null> | (() => number | null), 
	startMonth?: number | null | Ref<number | null> | (() => number | null), 
	columns?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _startYear = isRef<number | null>(startYear) ? startYear : ref<number | null>((typeof startYear === 'function') ? startYear() : startYear)
	const _startMonth = isRef<number | null>(startMonth) ? startMonth : ref<number | null>((typeof startMonth === 'function') ? startMonth() : startMonth)
	const _columns = isRef<string>(columns) ? columns : ref<string>((typeof columns === 'function') ? columns() : columns)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		startYear: _startYear,
		startMonth: _startMonth,
		columns: _columns,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof startYear === 'function') { _startYear.value = startYear() }
			if (typeof startMonth === 'function') { _startMonth.value = startMonth() }
			if (typeof columns === 'function') { _columns.value = columns() }

			return new c.CreatePnlCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _startYear.value, _startMonth.value, _columns.value)
		})
	}

	return {
		...result,
		authorizedCreatePnlCommandV1: result.authorized,
		createPnlCommandV1: result.command,
		completedCreatePnlCommandV1: result.completed,
		errorCreatePnlCommandV1: result.error,
		invokeCreatePnlCommandV1: result.invoke,
		invokingCreatePnlCommandV1: result.invoking,
		succeedCreatePnlCommandV1: result.succeed,
		validationErrorsCreatePnlCommandV1: result.validationErrors,
		onSucceedCreatePnlCommandV1: result.onSucceed,
	}
}

export function useDeletePnlCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeletePnlCommandV1(_workspaceId.value, _strategyId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeletePnlCommandV1: result.authorized,
		deletePnlCommandV1: result.command,
		completedDeletePnlCommandV1: result.completed,
		errorDeletePnlCommandV1: result.error,
		invokeDeletePnlCommandV1: result.invoke,
		invokingDeletePnlCommandV1: result.invoking,
		succeedDeletePnlCommandV1: result.succeed,
		validationErrorsDeletePnlCommandV1: result.validationErrors,
		onSucceedDeletePnlCommandV1: result.onSucceed,
	}
}

export function useUpdatePnlCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	startYear?: number | null | Ref<number | null> | (() => number | null), 
	startMonth?: number | null | Ref<number | null> | (() => number | null), 
	columns?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _startYear = isRef<number | null>(startYear) ? startYear : ref<number | null>((typeof startYear === 'function') ? startYear() : startYear)
	const _startMonth = isRef<number | null>(startMonth) ? startMonth : ref<number | null>((typeof startMonth === 'function') ? startMonth() : startMonth)
	const _columns = isRef<string>(columns) ? columns : ref<string>((typeof columns === 'function') ? columns() : columns)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		startYear: _startYear,
		startMonth: _startMonth,
		columns: _columns,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof startYear === 'function') { _startYear.value = startYear() }
			if (typeof startMonth === 'function') { _startMonth.value = startMonth() }
			if (typeof columns === 'function') { _columns.value = columns() }

			return new c.UpdatePnlCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _startYear.value, _startMonth.value, _columns.value)
		})
	}

	return {
		...result,
		authorizedUpdatePnlCommandV1: result.authorized,
		updatePnlCommandV1: result.command,
		completedUpdatePnlCommandV1: result.completed,
		errorUpdatePnlCommandV1: result.error,
		invokeUpdatePnlCommandV1: result.invoke,
		invokingUpdatePnlCommandV1: result.invoking,
		succeedUpdatePnlCommandV1: result.succeed,
		validationErrorsUpdatePnlCommandV1: result.validationErrors,
		onSucceedUpdatePnlCommandV1: result.onSucceed,
	}
}

